import Star from '@icon/Planner/SubscriptionStar';
import FilledSubscriptionStar from '@icon/Planner/FilledSubscriptionStar';
import { Spacings } from '@styles/index';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const StarContainer = styled.div`
  margin-right: ${Spacings.SPACING_3B};
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
`;

const SubscriptionRatingStars = ({
  maxRating,
  setRating,
  value,
  className
}) => {
  const data = value + 1;
  const [starNumber, setStarNumber] = useState(data);
  useEffect(() => {
    setStarNumber(data);
  }, [data]);

  const handleMouseLeave = () => setStarNumber(data);
  const handleMouseEnter = (index) => () => setStarNumber(index + 2);

  const handleClick = (ratingValue) => () => {
    setRating(ratingValue)();
    setStarNumber(data);
  };

  return (
    <Wrapper onMouseLeave={handleMouseLeave} className={className}>
      {Array.from({ length: maxRating }, (v, k) => k + 1).map(
        (rating, index) => (
          <StarContainer
            key={rating}
            onMouseEnter={handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            {rating >= starNumber && (
              <Star
                color="var(--color-i-brown-3)"
                size={Spacings.SPACING_6B}
                onClick={handleClick(rating)}
                key={rating}
              />
            )}
            {rating < starNumber && (
              <FilledSubscriptionStar
                color="var(--color-i-brown-3)"
                size={Spacings.SPACING_6B}
                onClick={handleClick(rating)}
                key={rating}
              />
            )}
          </StarContainer>
        )
      )}
    </Wrapper>
  );
};

SubscriptionRatingStars.propTypes = {
  maxRating: PropTypes.number,
  setRating: PropTypes.func,
  value: PropTypes.number.isRequired,
  className: PropTypes.string
};
SubscriptionRatingStars.defaultProps = {
  maxRating: 5,
  setRating: () => {},
  className: ''
};

export default SubscriptionRatingStars;
